import React from 'react'
import { authRoles } from 'app/auth/authRoles'

const superAdminRoutes = [
    {
        path: '/superadmin/tariffs',
        exact: true,
        component: React.lazy(() => import('./TariffManagementPage')),
        auth: authRoles.sa,
    },
    {
        path: '/superadmin',
        exact: true,
        component: React.lazy(() => import('./SuperAdminPage')),
        auth: authRoles.sa,
    },
]

export default superAdminRoutes
